// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"537acd89","732":"9d99e4b7","977":"f64b31b1"}[chunkId] + ".chunk.js";
};